<template>
  <div class="upload_box">
    <van-uploader
      :after-read="afterRead"
      :before-read="beforeRead"
      :max-size="2048 * 1024"
      :fileList="value"
      :preview-image="false"
      @oversize="onOversize"
    >
      <van-cell is-link>
        <template>
          <van-loading v-if="uploadLoding" type="spinner" color="#1989fa" />
          <div v-else>
            <img
              v-if="value.length"
              class="upload_img"
              :src="$global.imgUrl + value[0]"
              alt=""
            />
            <span v-else>请上传</span>
          </div>
        </template>
      </van-cell>
    </van-uploader>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "CellUpload",
  props: {
    value: {
      type: Array,
    },
    type: String,
    name: String,
  },
  data() {
    return {
      uploadLoding: false,
    };
  },
  methods: {
    async compressImg(base64, name) {
      // 处理缩放，转换格式
      // 用canvas来压缩
      const img = new Image();
      img.src = base64;
      return new Promise(function (resolve, reject) {
        img.onload = async function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.setAttribute("width", this.width);
          canvas.setAttribute("height", this.height);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          // 转成base64 文件  0.5 缩放比例
          base64 = canvas.toDataURL("image/jpeg", 0.5);
          const arr = base64.split(",");
          const mime = arr[0].match(/:(.*?);/)[1];
          const bytes = atob(arr[1]);
          const bytesLength = bytes.length;
          const u8arr = new Uint8Array(bytesLength);
          for (let i = 0; i < bytes.length; i++) {
            u8arr[i] = bytes.charCodeAt(i);
          }
          const file = await new File([u8arr], name, { type: mime });
          resolve(file);
        };
      });
    },
    async blobToBase64(blob) {
      const _this = this;
      const reader = new FileReader(); // 实例化一个reader文件
      reader.readAsDataURL(blob); // 添加二进制文件
      return new Promise(function (resolve, reject) {
        reader.onload = async function (event) {
          const base64 = await event.target.result; // 获取到它的base64文件
          let file = await _this.compressImg(base64, blob.name);
          resolve(file);
        };
      });
    },
    async beforeRead(file) {
      if (file.size > 2048 * 1024) {
        // 压缩图片
        let imgFile = await this.blobToBase64(file);
        return imgFile;
      }
    },
    // 图片上传
    async afterRead(file) {
      this.uploadLoding = true;
      let formDataParams = new FormData();
      formDataParams.append("file", file.file);
      formDataParams.append("enums", this.type);
      const payRes = await this.$apis.zzsignServe.ocrUpload(formDataParams);
      if (payRes.resultCode === "200") {
        console.log(payRes.data, "payRes.data");
        this.uploadLoding = false;
        this.$emit("input", [payRes.data]);
        this.$emit("change", payRes.content);
      } else {
        Toast("图片上传失败!");
        this.uploadLoding = false;
      }
    },
    onOversize(file) {
      Toast("图片不可大于2Mb!");
    },
  },
};
</script>

<style scoped lang="scss">
.upload_box {
  width: 100%;

  &::v-deep .van-cell__value {
    text-align: right;
  }

  &::v-deep .van-cell {
    padding: 0 !important;
    border: none !important;

    &::after {
      border: none;
    }
  }

  .upload_img {
    width: 65px;
    height: 41px;
  }
}
</style>
